import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { CurrentUser, getCurrentUser, UserState } from 'ducks/users'

const UserEmailValidationRedirect = (props: {
  currentUser: CurrentUser
}): JSX.Element | null => {
  const { currentUser } = props

  if (!currentUser || process.env.NODE_ENV === 'test') {
    return null
  }

  // If emailValidationString exists, they haven't verified their email yet
  const { emailValidationString } = currentUser

  if (emailValidationString) {
    return <Redirect to="/email-validation" />
  }

  return null
}

const mapStateToProps = (state: UserState) => ({
  currentUser: getCurrentUser(state),
})

export default connect(mapStateToProps)(UserEmailValidationRedirect)
